// extracted by mini-css-extract-plugin
module.exports = {"button":"AnswersSection_button__2q8Ry","full-width-avatar":"AnswersSection_full-width-avatar__nF2Nq"};